import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useNavigate } from 'react-router-dom';

import { ConfirmDialog, UiModal } from 'shared/ui';
import {
  isErrorWithMessage,
  openErrorNotification,
  openSuccessNotification,
} from 'shared/lib';

import { useDeleteCarModelMutation } from 'entities/car-model';

import { DELETE_ERROR, DELETE_SUCCESS } from '../consts';
import { CAR_BRAND_ROUTES } from 'shared/consts/routes/car-brands';

type Props = {
  id: string;
  name: string;
};

export const DeleteCarModelModal = NiceModal.create((props: Props) => {
  const modal = useModal();

  const navigate = useNavigate();

  const [trigger, { isLoading }] = useDeleteCarModelMutation();

  const { id, name } = props;

  const handleDelete = async () => {
    try {
      const res = await trigger(id).unwrap();

      if (res.statusCode !== 0) {
        openErrorNotification(res.statusDescription);
        return;
      }

      openSuccessNotification(DELETE_SUCCESS);

      // TODO
      navigate(CAR_BRAND_ROUTES.CAR_BRANDS);
    } catch (err) {
      const hasErrorMessage = isErrorWithMessage(err);

      const errorText = hasErrorMessage
        ? err.data.statusDescription
        : DELETE_ERROR;

      openErrorNotification(errorText);
    } finally {
      modal.hide();
    }
  };

  return (
    <UiModal
      title={`Удалить модель автомобиля "${name}"?`}
      visible={modal.visible}
      onCancel={modal.hide}
      afterClose={modal.remove}
    >
      <ConfirmDialog
        onCancel={modal.hide}
        onConfirm={handleDelete}
        loading={isLoading}
      />
    </UiModal>
  );
});
